import React from "react";
import Button from "../../../shared/components/atoms/button/button";
import { siteUrl } from '../../../shared/utils/siteUrl';
import "./contact-footer.scss";

const ContactFooter = ({ mobile }) => {

  var contactLink = siteUrl + '/contactanos'
  return (
    <div className="f-contact-footer">
      <span className="f-contact-curve" />
      <div className="f-contact-footer-wrap">

        {!mobile && <div className="f-image-contact" />}

        <div className="f-contact-footer-wrap-info-container">
          <div className="f-contact-footer-wrap-info-container-title">
            <h2>¿Qué hago si no puedo ingresar mis claves? </h2>
          </div>
          <div className="f-contact-footer-wrap-info-container-description">
            <p>
              {process.env.LOCALE === "es-AR" || process.env.LOCALE === "es-UY" || process.env.LOCALE === "es-PY" ? 
              `Si tenés problemas con el ingreso de tus claves, llamanos a nuestra Línea de Atención al Cliente ${process.env.COUNTRY_CONTACT} para ayudarte o también podés escribirnos en nuestras redes sociales. .` : 
              `Si tienes problemas con el ingreso de tus claves, llámanos a nuestra Línea de Atención al Cliente ${process.env.COUNTRY_CONTACT} para ayudarte o también puedes escribirnos.`} 
            </p>
          </div>
          <Button className="primary-blue" title="Contáctanos" onClick={e => { e.preventDefault(); window.location = contactLink }} />
        </div>
      </div>
    </div>
  )
}

export default ContactFooter;